<template>
    <div class="d-inline-block">
        <b-button
            :variant="buttonVariant"
            :size="buttonSize"
            :block="buttonBlock"
            @click="modalShowing = true"
        >
            <b-icon :icon="buttonIcon" class="mr-1"></b-icon>
            {{ buttonText }}
        </b-button>

        <b-modal
            v-model="modalShowing"
            :size="modalSize"
            :title="modalTitle"
            hide-footer
            centered
        >
            <slot>
                Put instructions here
            </slot>
        </b-modal>
    </div>
</template>

<script>

export default {
    name: 'InstructionsModal',
    components: {},
    props: {
        buttonText: {
            type: String,
            default: 'Instructions',
        },
        buttonVariant: {
            type: String,
            default: 'light-info',
        },
        buttonSize: {
            type: String,
            default: 'md',
        },
        buttonBlock: {
            type: Boolean,
            default: false,
        },
        buttonIcon: {
            type: String,
            default: 'question-circle',
        },
        modalSize: {
            type: String,
            default: 'md',
        },
        modalTitle: {
            type: String,
            default: 'Instructions',
        },
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            modalShowing: false,  // v-model to show / hide modal
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>

<style>

</style>